// Omnix/client/ui/WorkflowSelectorModal.js
import { ComponentBase } from "../core/ComponentBase.js";

export class WorkflowSelectorModal extends ComponentBase {
    constructor(config) {
        super(config);
        this.channelConfig = null;
        this.modalInstance = null;
    }

    async initialize() {
        this.container = document.createElement('div');
        this.container.className = 'modal fade';
        this.container.id = `${this.config.instanceId}-modal`;
        this.container.innerHTML = `
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Set Inbound Workflow</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body" id="workflow-selector-body">
                        <!-- Form fields will be rendered here -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" id="save-workflow-btn">Save Changes</button>
                    </div>
                </div>
            </div>
        `;
        this.modalInstance = new bootstrap.Modal(this.container);
        this.container.querySelector('#save-workflow-btn').addEventListener('click', this.handleSave.bind(this));
        await super.initialize();
    }

    async show(channelConfig) {
        this.channelConfig = channelConfig;
        await this.renderBody();
        this.modalInstance.show();
    }

    async renderBody() {
        const body = this.container.querySelector('#workflow-selector-body');
        body.innerHTML = ''; // Clear previous

        if (this.channelConfig.provider === 'twilio') {
            // Special case for Twilio with two selectors
            body.appendChild(await this.createWorkflowSelect('inboundSmsWorkflowId', 'Inbound SMS Workflow', 'messaging'));
            body.appendChild(await this.createWorkflowSelect('inboundVoiceWorkflowId', 'Inbound Voice Workflow', 'voice'));
        } else {
            // Standard case for all other channels
            body.appendChild(await this.createWorkflowSelect('inboundWorkflowId', 'Inbound Workflow', 'messaging'));
        }
    }

    async createWorkflowSelect(fieldId, label, tagFilter) {
        const container = document.createElement('div');
        container.className = 'mb-3';

        const labelEl = document.createElement('label');
        labelEl.htmlFor = fieldId;
        labelEl.className = 'form-label';
        labelEl.textContent = this.t(label);
        container.appendChild(labelEl);

        const selectEl = document.createElement('select');
        selectEl.id = fieldId;
        selectEl.className = 'form-select';
        selectEl.innerHTML = `<option value="">Default (Direct to Inbox)</option>`;
        container.appendChild(selectEl);

        try {
            const workflows = await this.appClient.rpcClient.call('ChannelManagerRpc.getFieldValues', {
                fieldName: fieldId,
                reference: { collection: 'workflows', valueField: '_id', displayField: 'name', filter: { tags: tagFilter } }
            });
            workflows.forEach(wf => {
                const option = document.createElement('option');
                option.value = wf.value;
                option.textContent = wf.label;
                selectEl.appendChild(option);
            });
            // Set the current value
            selectEl.value = this.channelConfig[fieldId] || '';
        } catch (error) {
            this.log.error(`Failed to populate workflow select for ${fieldId}:`, error);
        }

        return container;
    }

    handleSave() {
        const workflowIds = {};
        if (this.channelConfig.provider === 'twilio') {
            workflowIds.inboundSmsWorkflowId = this.container.querySelector('#inboundSmsWorkflowId').value || null;
            workflowIds.inboundVoiceWorkflowId = this.container.querySelector('#inboundVoiceWorkflowId').value || null;
        } else {
            workflowIds.inboundWorkflowId = this.container.querySelector('#inboundWorkflowId').value || null;
        }

        this.emit('workflowSelected', { channelId: this.channelConfig._id, workflowIds });
        this.modalInstance.hide();
    }

    render() { return this.container; }
}